import { DataOrigins, ShowroomService } from '@sm360/widget-commons-vehicle';

import {
    loadPurchaseMethodsSuccess,
    selectPaymentFrequency,
} from 'payment-calculator/actions/paymentCalculatorActions.js';
import { LocalStorageService } from '@sm360/widget-commons-general';
/* eslint import/prefer-default-export: 0 */

export function loadPurchaseMethods() {
    return (dispatch) => {
        return ShowroomService.getModelYear(DataOrigins.MODELS_COLLECTION, 2017, 'MAZDA', 'CX-3', 'SV', '', 'fr-CA')
            .then((vehicle) => {
                const paymentFrequency = LocalStorageService.get('paymentFrequency');
                dispatch(loadPurchaseMethodsSuccess(vehicle));

                if (paymentFrequency) {
                    dispatch(
                        selectPaymentFrequency({
                            value: parseInt(paymentFrequency, 10),
                        })
                    );
                }
            })
            .catch((error) => {
                throw error;
            });
    };
}
